import { AxiosInstance } from 'axios'
import { DocumentSearchResult } from '@dc-shared-web/hooks/api/document'
import {
  CubeDocumentSearchResult,
  mapCubeToDocument,
} from '@dc-shared-web/lib/cubeMappers'

export type GetSearchResultQueryParams = {
  visitorTimeZone: string
  sort: string
  sortDirection: 'desc' | 'asc'
  currentTeam: string
  crunchDate?: string
  solutionType?: string
  documentTypeName?: string
  offset: number
  searchTerm: string
  currentTable: string
}

export const fetchDocumentSearchResults = async (
  apiClient: AxiosInstance,
  params?: GetSearchResultQueryParams
): Promise<DocumentSearchResult[]> => {
  const {
    data: { data },
  } = await apiClient.get(`/ajax/cube/tableSearch`, {
    params,
  })

  return data.map((item: CubeDocumentSearchResult) => mapCubeToDocument(item))
}
